// extracted by mini-css-extract-plugin
export default {"root":"ProfileContent-modules__root__ipd8h","show-keyframe":"ProfileContent-modules__show-keyframe___EzSl"};